import React, { Component } from "react";
import { connect } from "react-redux";

import { saveJournal, updateJournal, deleteJournal } from "../../../store/actions/journalAction";
import SelectJournal from "../../../components/SelectJournal";
import { loadComptes } from "../../../store/actions/compteAction";

import { toast } from "react-toastify";

class Journals extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.loadComptes();
  }

  saveJournal = (data) => {
    this.props
      .saveJournal(data)
      .then((res) => toast.success("Journal créé !", { containerId: "A" }))
      .catch((err) => toast.error("Échec lors de la création !", { containerId: "A" }));
  };

  updateJournal = (data, id) => {
    this.props
      .updateJournal(data, id)
      .then((res) => toast.success("Journal édité !", { containerId: "A" }))
      .catch((err) => toast.error("Échec lors de l'édition !", { containerId: "A" }));
  };

  render() {
    const { utilisateur, journals, comptes, typesPaiements } = this.props;

    const journalsSorted = journals.sort((a, b) => a.journal_code.localeCompare(b.journal_code));

    return (
      <div>
        {journals && (
          <SelectJournal
            utilisateur={utilisateur}
            listData={journalsSorted}
            comptes={comptes}
            typesPaiements={typesPaiements}
            saveJournal={this.saveJournal}
            updateJournal={this.updateJournal}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveJournal: (journal) => dispatch(saveJournal(journal)),
    updateJournal: (journal, id) => dispatch(updateJournal(journal, id)),
    deleteJournal: (id) => dispatch(deleteJournal(id)),
    loadComptes: () => dispatch(loadComptes()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    journals: state.journals.data,
    comptes: state.comptes.data,
    typesPaiements: state.typesPaiements.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Journals);
